import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/breadcrumb.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
